/* eslint-disable */
import { TextField } from '@material-ui/core';
import P from 'prop-types';

export default function PercentsComponents({values, setValues, channelId}) {
    return (
        <>
            <TextField
                autoFocus
                margin="dense"
                label="Descrição"
                type="text"
                value={values.description}
                fullWidth
                required
                onChange={(e) => setValues({ ...values, description: e.target.value })}
              />

              <TextField
                autoFocus
                margin="dense"
                label="De"
                type="number"
                value={values.begin}
                fullWidth
                required
                onChange={(e) => setValues({ ...values, begin: e.target.value })}
              />

              <TextField
                margin="dense"
                label="Até"
                type="number"
                value={values.end}
                fullWidth
                onChange={(e) => setValues({ ...values, end: e.target.value })}
              />

              <TextField
                margin="dense"
                label="Comissão"
                type="number"
                value={values.commission}
                fullWidth
                onChange={(e) => setValues({ ...values, commission: e.target.value })}
              />

              { channelId == 4 ?
                <TextField
                  margin="dense"
                  label="Perda"
                  type="number"
                  value={values.loss_percent}
                  fullWidth
                  onChange={(e) => setValues({ ...values, loss_percent: e.target.value })}
                /> :
                <TextField
                  margin="dense"
                  label="Conversão"
                  type="number"
                  value={values.conversion_percent}
                  fullWidth
                  onChange={(e) => setValues({ ...values, conversion_percent: e.target.value })}
                />
              }

              <TextField
                  margin="dense"
                  label="Comissão a considerar"
                  type="number"
                  value={values.reduce_percent}
                  fullWidth
                  onChange={(e) => setValues({ ...values, reduce_percent: e.target.value })}
                />        
        </>
    )
}

PercentsComponents.propTypes = {
    values: P.arrayOf(P.object).isRequired,
    setValues: P.func.isRequired,
    channelId: P.number.isRequired,
  };